import { Component, computed, ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import { TModalActAccessSteps } from '@/models/act/act-access.interface';
import { ActiveModalActAccessStates, ModalActAccessStates } from '@/models/modal/modal.enum';
import ActAddUsers from '@/presentation/components/act-access-modal/act-add-users/act-add-users.vue';
import ActSelectDashboards from '@/presentation/components/act-access-modal/act-select-dashboards/act-select-dashboards.vue';
import ActSetAccessPeriods from '@/presentation/components/act-access-modal/act-set-access-periods/act-set-access-periods.vue';
import ActReviewAndConfirm from '@/presentation/components/act-access-modal/act-review-and-confirm/act-review-and-confirm.vue';
import actStore from '@/store/act';

export default class ActAccessModalCode {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);

	private modalSteps: TModalActAccessSteps = {
		[ModalActAccessStates.ADD_USERS]: ActAddUsers as Component,
		[ModalActAccessStates.SELECT_DASHBOARDS]: ActSelectDashboards as Component,
		[ModalActAccessStates.SET_ACCESS_PERIODS]: ActSetAccessPeriods as Component,
		[ModalActAccessStates.REVIEW_AND_CONFIRM]: ActReviewAndConfirm as Component
	};

	// eslint-disable-next-line @typescript-eslint/naming-convention
	public ComponentForActiveStep = computed((): Component => {
		return this.modalSteps[this.modalActAccessState.value];
	});

	private modalActAccessState = computed((): ActiveModalActAccessStates => {
		return actStore.actGetters.modalActAccessState() as ActiveModalActAccessStates;
	});

	public mounted(): void {
		this.prepareModal();
	}

	public unmounted(): void {
		window.ModalManager.close(this.modal.value);
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.modalContent.value, {
			cssClassName: 'ActAccessModalWrapper',
			destroyOnClose: false,
			onClose: this.closeModal.bind(this)
		});

		window.ModalManager.open(this.modal.value);
	}

	private closeModal(): void {
		actStore.actMutations.setModalActAccessState(ModalActAccessStates.INACTIVE);
		actStore.actMutations.setSelectedActInvoiceNumber(0);
		actStore.actMutations.resetActAccessModalFields();
	}
}
